import { useCurrency } from '@features/currency/currency.hooks';

const QuantityPriceCell = (props: {
  value: number;
  unit: string;
  totalPrice: number;
  type: string;
}) => {
  const { value, unit, totalPrice, type } = props;
  const isSaleGoods = type === 'SALE';
  const { preferredCurrency } = useCurrency();
  return (
    <>
      {value} <span style={{ color: '#888', marginLeft: 0 }}>{`${isSaleGoods ? 'ks' : unit}`}</span>
      {' / '}
      {Math.round(totalPrice)}
      <span style={{ color: '#888', marginLeft: 0 }}>{` ${preferredCurrency}`}</span>
    </>
  );
};
export default QuantityPriceCell;
